import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    arrow: {
        fill: '#fff', width: 10, height: 10,
    },
    wrapTitle: {
        paddingLeft: 8,
        paddingBottom: '6px',
        marginTop: 20,
        paddingTop: '4px',
        marginBottom: '8px',
        borderBottom: '1px solid #ccc',
        width: '97%',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingRight: 12,
    },
    title: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: '14px',
        lineHeight: '17px',
        userSelect: 'none',
        fontFamily: 'PT Sans,sans-serif',
        color: '#fff',
    }
}));

const getRows = (rezymeArr) => {
    return rezymeArr.map((item) => {
        return {
            id: item.uuid,
            name: item.game,
            bet: item.count, 
            sum_bet: new Intl.NumberFormat('ru-RU').format(item.sum) + '₽',
            sum_win: new Intl.NumberFormat('ru-RU').format(item.sum_win) + '₽',
            difference: new Intl.NumberFormat('ru-RU').format(+item.sum - +item.sum_win) + '₽',
            rtp: (item.sum_win / item.sum * 100).toFixed(0) + '%'
        }
    })
}

const columns = [
    { id: 'id', label: 'ID игры'},
    { id: 'name', label: 'Название игры'},
    { id: 'bet', label: 'Количество'},
    { id: 'sum_bet', label: 'Сумма ставок'},
    { id: 'sum_win', label: 'Сумма выигрышей'},
    { id: 'difference', label: 'Разница'},
    { id: 'rtp', label: 'Среднее RTP (%)'},
];

export {
    useStyles,
    columns,
    getRows
}